<template>
  <v-container v-if="computedLocation != null && computedDetail != null" class="drop--overview--context__container pa-0">
    <v-row class="pa-0 drop--overview--context__layout" no-gutters>
      <v-col class="drop--overview--context__component pa-2" cols="12">
        <DropsContextLocation :selectedDrop="computedLocation" />
      </v-col>
      <v-col class="drop--overview--context__component pa-2" cols="12">
        <DropsContextDetail :selectedDrop="computedDetail.drop" />
      </v-col>
      <v-col  class="drop--overview--context__component pa-2" cols="12">
        <DropsContextShipment :selectedDrop="computedDetail.drop" />
      </v-col>
      <!-- Remove for now -->
      <!-- <v-flex  class="drop--overview--context__component" xs12 pa-2>
        <ContextExpandList :title="$t('drops.shipping_units')" :list="computeExpandList" />
      </v-flex> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import DropsContextLocation from '@/components/drops/location/DropsContextLocation.vue'
import DropsContextDetail from '@/components/drops/detail/DropsContextDetail.vue'
import DropsContextShipment from '@/components/drops/detail/DropsContextShipment.vue'
// import ContextExpandList from '@/components/drops/detail/ContextExpandList.vue'
export default {
  name: 'DropOverviewContext',
  components: {
    DropsContextLocation,
    DropsContextDetail,
    DropsContextShipment
    // ContextExpandList
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getDropDetails'
    ]),
    computedLocation: function () {
      if (this.getDropDetails !== null) {
        const { id, departure, arrival, destination, origin, pickupLocal, deliveryLocal } = this.getDropDetails
        const locationObject = {
          id,
          departure: departure != null ? departure : pickupLocal.from,
          arrival: arrival != null ? arrival : deliveryLocal.from,
          destination: {
            id: destination.id,
            companyName: destination.orgName !== undefined ? destination.orgName : destination.organization.name,
            address: destination.address,
            organizationRef: destination.organization != null ? destination.organization.ref : null,
            locationRef: destination.ref,
            openingHours: destination.openingHours,
            accessibility: destination.accessibility,
            equipment: destination.equipment,
            coordinates: destination.coordinates
          },
          origin: {
            id: origin.id,
            companyName: origin.orgName !== undefined ? origin.orgName : origin.organization.name,
            address: origin.address,
            organizationRef: origin.organization != null ? origin.organization.ref : null,
            locationRef: origin.ref,
            openingHours: origin.openingHours,
            accessibility: origin.accessibility,
            equipment: origin.equipment,
            coordinates: origin.coordinates
          }
        }
        return locationObject
      }
      return null
    },
    computedDetail: function () {
      if (this.getSelectedResource !== null) {
        const { units } = this.getSelectedResource
        if (units != null) {
          if (typeof (units) === 'number') {
            return { units: null }
          }
          const detailObject = { drop: this.getSelectedResource, units: units }
          return detailObject
        }
        return { units: null }
      }
      return null
    }
    // computeExpandList () {
    //   if (this.getSelectedResource.units.constructor === Array) {
    //     if (typeof this.getSelectedResource.units !== 'number') {
    //       let labelsArray = []
    //       this.getSelectedResource.units.forEach((unit) => {
    //         if (unit.type === 'CustomBox') {
    //           labelsArray.push({ name: this.$t('packages_type.box'), value: { ...unit, weight: dropHelpers.calculateUnitWeight(unit) } })
    //         } else {
    //           labelsArray.push({ name: this.$t('packages_type.pallet'), value: { ...unit, weight: dropHelpers.calculateUnitWeight(unit) } })
    //         }
    //       })
    //       return labelsArray
    //     } else {
    //       return []
    //     }
    //   }
    //   return []
    // }
  },
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
